const Footer = () => {
    return (
        <footer className='pa3 f6 black-70'>&copy; {new Date().getFullYear()} mpathic</footer>
    );
}

export default Footer;